@if (consultant$ | async; as consultant) {
  <div class="consultant justify-content-space-between">
    @if (automatic) {
      <div class="title-mobile title">
        {{ getTypeObject().title }}
      </div>
    }
    @if (!automatic) {
      <div class="title-mobile title">
        {{ getTypeObject().altTitle }}
      </div>
    }
    <div class="content">
      @if (consultant.pictureFile) {
        <div class="img-profil">
          <div
            class="img-wrap"
            [ngStyle]="{
              'background-image':
                'url(' + consultant.pictureFile ||
                'assets/img/consultants/Consultant-defaut-PP.png' + ')',
            }"
          ></div>
        </div>
      }
      <div class="infos">
        <div>
          @if (automatic) {
            <div class="title-desktop title">
              {{ getTypeObject().title }}
            </div>
          }
          @if (!automatic) {
            <div class="title-desktop title">
              {{ getTypeObject().altTitle }}
            </div>
          }
          @if (isSubscrible) {
            @if (automatic) {
              <div class="sub-title">
                Souscrivez 100% en ligne dans ce portefeuille ou
                <button
                  class="rdv-link"
                  title-action
                  (click)="showModal($event, template)"
                  [eaAnalyticEvent]="[productLabel, 'footer', 'prendre rdv']"
                >
                  prenez rendez-vous
                </button>
                avec votre conseiller pour être accompagné dans votre projet.
              </div>
            }
            @if (!automatic) {
              <div class="sub-title">
                Faites vous accompagner par votre conseiller
                {{ consultant.firstName }} {{ consultant.lastName }} pour
                choisir les supports les plus adaptés a votre projet.
              </div>
            }
          } @else {
            <div class="sub-title">
              {{ getTypeObject().altContent }}
            </div>
          }
        </div>
      </div>
    </div>
    <div class="d-flex vertical-center">
      <!-- Verifier les boutons et les conditions, pour AV faire la souscription pour PER coté client mettre l'id du per en queryParams, pour le reste envoyer sur la page de souscription de productType -->
      @if (isSubscrible) {
        @if (automatic) {
          <div>
            @if (productType && !isConsultant) {
              <button class="cta" (click)="navigateToDashboard()">
                {{ getTypeObject().labelBtn }}
              </button>
            }
            @if (productType && isConsultant) {
              <button
                class="cta"
                [routerLink]="'/dashboard/souscription/init'"
                [queryParams]="{ productType: productType }"
              >
                {{ getTypeObject().labelBtn }}
              </button>
            }
            @if (!productType) {
              <button
                class="cta"
                [routerLink]="'/dashboard/global/simulations'"
              >
                {{ getTypeObject().labelBtn }}
              </button>
            }
          </div>
        }
        @if (!automatic) {
          <div>
            <button
              class="cta"
              (click)="showModal($event, template)"
              [eaAnalyticEvent]="[productLabel, 'footer', 'prendre rdv']"
            >
              {{ getTypeObject().altLabelBtn }}
            </button>
          </div>
        }
      } @else {
        <button
          class="cta"
          (click)="showModal($event, template)"
          [eaAnalyticEvent]="[productLabel, 'footer', 'prendre rdv']"
        >
          {{ getTypeObject().labelBtn }}
        </button>
      }
    </div>
  </div>
  <!-- modal -->
  <ng-template #template>
    <div class="modal-header text-center">
      <img
        src="assets/img/sheets/contact-pop.png"
        width="138"
        alt="PRENDRE RENDEZ-VOUS"
        [eaAnalyticEvent]="['cta', 'footer', 'prendre rdv']"
      />
      <button
        type="button"
        class="close pull-right"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body text-center">
      @if (submitting) {
        <i class="fa fa-spinner fa-spin text-primary"></i>
      }
      @if (!submitting) {
        @if (hasPhone) {
          <p class="text-primary text-title">
            Votre conseiller {{ consultant.firstName }}
            {{ consultant.lastName }} est prévenu 📩
          </p>
          <p class="text-gray text-subtitle">
            Votre conseiller étudie votre demande et vous rappelle dans les plus
            brefs délais
          </p>
          <div class="btn-modal-contact">
            <button
              type="button"
              class="btn btn-success"
              (click)="modalRef.hide()"
            >
              Fermer
            </button>
          </div>
        }
        @if (!hasPhone) {
          <p class="text-title text-primary">
            Entrez votre numéro afin que votre conseiller puisse vous rappeler
            ☎
          </p>
          <form
            [formGroup]="numberForm"
            (ngSubmit)="onNumberForm(numberForm)"
            novalidate
          >
            <input type="text" formControlName="phone" placeholder="06..." />
            <div class="btn-modal-contact">
              <button type="submit" class="btn btn-success">Envoyer</button>
            </div>
          </form>
        }
      }
    </div>
  </ng-template>
  <!-- Loader à revoir -->
  @if (loading) {
    <pr-loader></pr-loader>
  }
}
